export const removeDivWithOutData = {
	inserted(el) {
	  // Function to check if an element or its children have content
	  const hasContent = (element) => {
		// Check if the element has child nodes or text
		if (element.childNodes.length > 0) {
		  return Array.from(element.childNodes).some(node => {
			// Check if any node has text content or is an element with children
			return (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') ||
				   (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0);
		  });
		}
		return false;
	  };
  
	  // Function to remove an element if it and its children are empty
	  const checkAndRemove = (el) => {
		// If the element itself is empty, check if it has any children with content
		if (!hasContent(el)) {
		  if (el.parentNode) {
			el.parentNode.removeChild(el);
		  }
		}
	  };
  
	  // Initially check the current element
	  checkAndRemove(el);
  
	  // Check all child elements of the current element
	  Array.from(el.children).forEach(child => checkAndRemove(child));
	}
  };
  